import "./../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LinkCard from "../components/LinkCard";
import TextCard from "../components/TextCard";
import {
  ReligiousResourcesEntries,
  ReligiousToolsEntries,
} from "../data/LinkCardEntries";

export default function SpiritualLife() {
  const FavoriteBibleVerseText =
    '"But those who wait on the LORD shall renew their strength; They shall mount up with wings like eagles, They shall run and not be weary, They shall walk and not faint." - Isaiah 40:31 NKJV';

  const PersonalResourcesText =
    '"I am a New Testament Christian. I believe in an omnipotent, omniscient, omnipresent God who desires for all people to be saved. I believe that Jesus Christ is the Son of God and He died for the remission of the sins of the world. I believe that there is one truth and one path to salvation. If you are interested in learning more about God and Christianity, take a look at the resources below."';

  const PersonalToolsText =
    '"In addition to study resources, the following tools can be helpful for studying the Bible. While I cannot vouch for the validity of any doctrine being taught on these sites, I have used them for the purpose of studying God\'s word."';

  return (
    <div className="App min-w-screen min-h-screen bg-home-page">
      <Navbar />
      <h1 className="text-5xl text-center my-8">Spiritual Life</h1>
      <div className="flex justify-center mt-12">
        <h3 className="text-2xl text-center mt-6">My Favorite Bible Verse</h3>
        <div className="eagle-image w-20 h-20">
          <img
            src={process.env.PUBLIC_URL + "/images/Eagle.png"}
            alt="eagle silhouette"
          />
        </div>
      </div>
      <p className="text-center mt-4 mb-8 w-96 text-wrap m-auto">
        {FavoriteBibleVerseText}
      </p>
      <div className="px-80 mdw:px-40 smw:px-20 xsw:px-4 gap-10 flex flex-col place-content-evenly mb-8">
        <TextCard message={PersonalResourcesText} />
        {ReligiousResourcesEntries.map((e) => (
          <LinkCard entry={e} />
        ))}
        <TextCard message={PersonalToolsText} />
        {ReligiousToolsEntries.map((e) => (
          <LinkCard entry={e} />
        ))}
      </div>
      <Footer />
    </div>
  );
}
